import {PreviewSegment} from "common/flowmaster/types/amendment";

export function plainText(segments: PreviewSegment[]): string {
  return segments
    .filter(segment => segment.kind !== "deleted")
    .map(segment => segment.text)
    .join("");
}

function splitAt(
  segments: PreviewSegment[],
  plainPos: number,
): PreviewSegment[] {
  const out: PreviewSegment[] = [];
  let pos = 0;
  segments.forEach(segment => {
    if (segment.kind === "deleted") {
      out.push(segment);
    } else {
      const end = pos + segment.text.length;
      if (plainPos > pos && plainPos < end) {
        out.push({...segment, text: segment.text.slice(0, plainPos - pos)});
        out.push({...segment, text: segment.text.slice(plainPos - pos)});
      } else {
        out.push(segment);
      }
      pos = end;
    }
  });
  return out;
}

// Marks plain-text range [start, end) as deleted and inserts `added` at end.
// Positions count kept and added text only.
export function applyEdit(
  segments: PreviewSegment[],
  start: number,
  end: number,
  added: string,
): PreviewSegment[] {
  const split = splitAt(splitAt(segments, start), end);
  const out: PreviewSegment[] = [];
  let pos = 0;
  let inserted = false;

  if (added && end === 0) {
    out.push({kind: "added", text: added});
    inserted = true;
  }

  split.forEach(segment => {
    if (segment.kind === "deleted") {
      out.push(segment);
    } else {
      const segStart = pos;
      const segEnd = pos + segment.text.length;
      pos = segEnd;
      const inside = segStart >= start && segEnd <= end && segEnd > segStart;
      if (!inside) {
        out.push(segment);
      } else if (segment.kind === "kept") {
        out.push({kind: "deleted", text: segment.text});
      }
      if (added && !inserted && segEnd === end && segEnd > 0) {
        out.push({kind: "added", text: added});
        inserted = true;
      }
    }
  });

  if (added && !inserted) {
    out.push({kind: "added", text: added});
  }
  return out;
}

export function isTouched(segments: PreviewSegment[]): boolean {
  return segments.some(segment => segment.kind !== "kept");
}
